import { createAsyncThunk } from '@reduxjs/toolkit';
import { Catalog } from '~api/catalog';

export const getBannersAll = createAsyncThunk(
  'banners/getBannersAll',
  async (params) =>
    await Catalog.bannersAllRequest(params).then(({ data: { data } }) => data),
);
